var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 0C15.2041 0 16 0.850658 16 1.9V13.3C16 14.3494 15.2041 15.2 14.2222 15.2H12.4444V17.1C12.4444 18.1494 11.6485 19 10.6667 19H1.77778C0.795938 19 0 18.1494 0 17.1V5.7C0 4.65066 0.795938 3.8 1.77778 3.8H3.55556V1.9C3.55556 0.850658 4.35149 0 5.33333 0H14.2222ZM6.22222 12.35H4.44444C3.95353 12.35 3.55556 12.7753 3.55556 13.3C3.55556 13.7872 3.89871 14.1887 4.34078 14.2436L4.44444 14.25H6.22222C6.71316 14.25 7.11111 13.8247 7.11111 13.3C7.11111 12.8128 6.76798 12.4113 6.32589 12.3564L6.22222 12.35ZM14.2222 1.9H5.33333V3.8H10.6667C11.6485 3.8 12.4444 4.65066 12.4444 5.7V13.3H14.2222V1.9ZM8 8.55H4.44444C3.95353 8.55 3.55556 8.97532 3.55556 9.5C3.55556 10.0247 3.95353 10.45 4.44444 10.45H8C8.49093 10.45 8.88889 10.0247 8.88889 9.5C8.88889 8.97532 8.49093 8.55 8 8.55Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.832d6f9d194d76256a281a04b3fbef28.svg";
export { ForwardRef as ReactComponent };